// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608171004/js/" + chunkId + "." + {"44":"c4ecd25a","225":"db41c8ef","481":"2972615e","486":"4e71e1a8","770":"ccabcc91"}[chunkId] + ".0.6730456188187436.chunk.js";
};